import * as Yup from 'yup';
import * as Moment from 'moment';

import { UserService } from '@fnv-core/authentication';
import { PageTypeService } from '../services/PageTypeService';
import { FormService } from '../services/FormService';
import { PrintViewService } from '../services/PrintViewService';
import { ESBOnlineService } from '../services/ESBOnlineService';

export class KenticoValidatorUtils {
  static IsEmail(value){
    let validationSchemaShape : any = {};
    validationSchemaShape["email"] = Yup.string().email("invalid e-mail");

    var schema = Yup.object().shape(validationSchemaShape);
    try {
      schema.validateSync({["email"]: value});            
    } catch (error) {
      return false;
    }
    return true;
  }

  static hasValue(value) {
    return value !== undefined && value !== null && value !== '';
  }

  static isReadOnlyView(value) {
    return PageTypeService.getPageType() === "view" ;
  }

  static UserIsKaderlid(value) {
    return false;
  }

  static IsSummaryView(value) {
    return FormService.getIsSummaryView();
  }

  static IsAuthenticated() {
    return UserService.isAuthenticated();
  }

  static IsPrintView(value) {
    return PrintViewService.getPrintView();
  }

  static IsESBOnline() {
    return ESBOnlineService.getESBIsOnline();
  }

  static IsAgeYoungerThen16(value) {
    if (value === undefined || value == "") {
      return false;
    }

    let birthDate = Moment(value, 'DD-MM-YYYY' , true);
    if (birthDate.isValid()) {
        var age = Moment().diff(birthDate, 'years');
        if (age >= 13 && age < 16) {
            return true;
        }
    }

    return false;
  }
          
  static GetBooleanPropertyFromPayload(fieldName) {
    const payload = FormService.getPayload();
    if (!payload) {
      return false;
    }
    return payload[fieldName] === true;
  }

  static ContainsValue(items, search) {
    if (items.length > 0) {
      if (items.some((item) => item.value.toLowerCase().includes(search))) {
        return true;
      }
    }

    return false;
  }
}
